<form class="alert-form" [formGroup]="form" (ngSubmit)="submit()">
  <article class="alert-form__card">
    <header class="alert-form__summary-header">
      <strong>Notify summary</strong>
    </header>

    <div class="alert-form__body">
      @if (countryFlag()) {
        <p class="alert-form__flag" aria-hidden="true">{{ countryFlag() }}</p>
      }
      <h1 class="alert-form__course">
        {{ selection().courseName }}
        @if (locationDisplay()) {
          <span class="alert-form__course-sub">{{ locationDisplay() }}</span>
        }
      </h1>

      <section class="alert-form__section">
        <h2 class="alert-form__section-title">Tee Time</h2>
        <ul class="alert-form__meta">
          @if (selection().displayTime || selection().appointmentTime) {
            <li><span aria-hidden="true">🕒</span> {{ selection().displayTime || (selection().appointmentTime | date:'h:mm a') }}</li>
          }
          <li><span aria-hidden="true">📆</span> {{ selection().date | date:'EEE. d MMM yyyy' }}</li>
          <li><span aria-hidden="true">🏌️‍♂️</span> {{ selection().players }} players</li>
          <li><span aria-hidden="true">⛳️</span> {{ selection().holes }} Holes</li>
        </ul>
      </section>

      <section class="alert-form__section">
        <h2 class="alert-form__section-title">Your details</h2>

        @if (currentUser(); as user) {
          <div class="alert-form__contact">
            <span class="alert-form__contact-avatar">
              @if (user.imageUrl) {
                <img [src]="user.imageUrl" [alt]="user.name || ''" width="32" height="32">
              } @else {
                <img src="assets/images/userAvatarIcon.svg" alt="" width="32" height="32">
              }
            </span>
            @if (user.name) {
              <span class="alert-form__contact-name">{{ user.name }}</span>
            }
          </div>

          @if (user.email) {
            <div class="alert-form__field alert-form__field--readonly">
              <span class="alert-form__field-icon" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" stroke-width="1.6" />
                  <path d="m3 7 9 6 9-6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
              <span>{{ user.email }}</span>
            </div>
          }
        }

        <!-- Phone is taken from the user's account and shown read-only (not editable). -->
        @if (selection().phone) {
          <div class="alert-form__field alert-form__field--readonly">
            <span class="alert-form__field-icon" aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
              </svg>
            </span>
            <span>{{ selection().phone }}</span>
          </div>
        }
      </section>

      <!-- No cost summary on the Notify flow — setting an alert doesn't charge anything. -->

      <button type="submit"
              class="alert-form__cta"
              [disabled]="!interactive() || submitted()">
        {{ submitted() ? 'Saving…' : 'Save Notification' }}
      </button>

      @if (termsAndConditions(); as terms) {
        <p class="alert-form__terms">
          @if (terms.link) {
            By proceeding with your booking, you acknowledge and accept the
            <a [href]="terms.link" target="_blank" rel="noopener noreferrer">Terms and Conditions</a>
            of GOLF.AI service.
          } @else {
            {{ terms.text }}
          }
        </p>
      } @else {
        <p class="alert-form__terms">
          By proceeding with your booking, you acknowledge and accept the Terms and Conditions of GOLF.AI service.
        </p>
      }
    </div>
  </article>
</form>
